function ReviewCtrl(ReviewService, ResolutionOptionService, $scope, $auth, $state, $location, $stateParams, AppSettings, AdminService, toaster, $rootScope, CommonService) {
  'ngInject';

  const vm = this;
  vm.reviews = [];
  vm.resolutions = [];
  vm.editUserForm = {};
  vm.loading = false;
  vm.date = !$stateParams.date ? moment() : moment.utc($stateParams.date);
  vm.year = vm.date.year();
  vm.yearArray = [...Array(new Date().getFullYear() - (2018 -1)).keys()].map(function (i) { return i + 2018 ; }).reverse();
  vm.month = vm.date.month() + 1;
  vm.months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  vm.monthName = vm.months[vm.month - 1];
  vm.tryNowDate = '';
  vm.dateRegex = AppSettings.dateRegex;
  vm.init = function () {
    vm.url = `/organizations/${$stateParams.orgId}/review_matrices.json?date=${vm.year}-${vm.month}-01`;
    vm.loading = true;
    if ($stateParams.orgId) {
      ReviewService.getReview(vm.url, function (response) {
        vm.loading = false;
        if (response.status == 200) {
          vm.reviews = response.data.review_matrices;
          vm.updateTitle();
        }
      });
    }
  };

  vm.updateTitle = function () {
    for(vm.i = 0;vm.i<vm.reviews.length;vm.i++){
      switch(vm.reviews[vm.i].title){
        case 'bill':
          vm.reviews[vm.i].title = 'Bill';
        break;
        case 'invoice':
          vm.reviews[vm.i].title = 'Invoice';
        break;
        case 'owner_contribution':
          vm.reviews[vm.i].title = 'Owner Contribution';
        break;
        case 'owner_distribution':
          vm.reviews[vm.i].title = 'Owner Distribution';
        break;
        case 'balance_sheet':
          vm.reviews[vm.i].title = 'Balance Sheet';
        break;
        case 'income_statement':
          vm.reviews[vm.i].title = 'Income Statement';
        break;
        case 'account_transaction':
          vm.reviews[vm.i].title = 'Account Transaction';
        break;
        case 'cross_check_sales':
          vm.reviews[vm.i].title = 'Cross Check Sales';
        break;
        default:
        vm.reviews[vm.i].title = vm.reviews[vm.i].title;
      }
    }
  };

  vm.monthReview = function (selectedMonth) {
    vm.monthName = vm.months[selectedMonth - 1];
    vm.month = selectedMonth;
    vm.changeYear();
  };

  vm.changeYear = function () {
    const month = vm.month > 9 ? vm.month : '0' + vm.month;
    $state.go('user.organization.dashboard.review', { date: `${vm.year}-${month}-01` });
  };

  vm.getFlag = function (flag) {
    if (flag == 'red') {
      return 'redFlag';
    } else if (flag == 'yellow') {
      return 'yellowFlag';
    } else {
      return 'noneFlag';
    }
  };

  vm.getFlagDetail = function (flag) {
    if (flag == 'red') {
      return 'redFlagDetail';
    } else if (flag == 'yellow') {
      return 'yellowFlagDetail';
    } else {
      return 'noneFlagDetail';
    }
  };

  vm.saveReview = function () {
    if (!vm.editUserForm.resolution_option) {
      toaster.pop('error', 'No resolution option selected');
    } else {
      vm.editUserForm.api_v1_resolution_option_id = vm.editUserForm.resolution_option.id;
      ReviewService.updateReview($stateParams.orgId, vm.editUserForm, function (response) {
        if (response.status >= 200 && response.status < 300) {
          vm.reviews[vm.reviews.map(function (a) { return a.id; }).indexOf(response.data.data.id)] = response.data.data;
          toaster.pop('info', 'Review information updated.');
          vm.editUserForm = {};
          vm.updateTitle();
        }
        else {
          toaster.pop('error', CommonService.throwError(response));
        }
        $('#editModal').modal('hide');
      });
    }
  };

  vm.editReview = function (reviewEdit) {
    vm.editUserForm = JSON.parse(JSON.stringify(reviewEdit));
    vm.reviewId = reviewEdit.id;
    vm.url = `/resolution_options.json`;
    ResolutionOptionService.listResolution(vm.url, function (response) {
      if (response.status == 200) {
        vm.resolutions = response.data.resolution_options;
        vm.editUserForm.resolution_option = vm.resolutions.find(function (d) { return d.id == vm.editUserForm.api_v1_resolution_option_id; });
      }
    });
    $('#editModal').modal('show');
  };

  vm.tryNow = function () {
    vm.tryLoading = true;
    ReviewService.tryNow($stateParams.orgId, vm.tryNowDate, function (response) {
      vm.tryLoading = false;
      if (response.status >= 200 && response.status < 300) {
        toaster.pop('info', response.data.data);
      } else {
        toaster.pop('error', CommonService.throwError(response));
      }
    });
  };

  vm.onTryNowDateSelect = function(pikaday) {
    vm.tryNowDate = pikaday.toString();
  };

  vm.onPikadayOpen = function (pikaday) {
    vm.tryNowPicker.setMaxDate(new Date());
  };

}
export default {
  name: 'ReviewCtrl',
  fn: ReviewCtrl
};
